import { UserCircle2, LogOut } from "lucide-react";

// The public login flow supports BOTH Emergent-managed Google OAuth and
// native email/password. The Google helper below is imported by
// /login, /signup, and any legacy CTA that still routes straight to
// Google. New surfaces should navigate to `/signup` (or `/login`) so
// the user can choose.
export function startGoogleLogin() {
  const params = new URLSearchParams(window.location.search);
  const next = params.get("next");
  if (next) localStorage.setItem("iti.postLoginRedirect", next);
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

/**
 * Sparkle glyph — the brand mark that shows up in the nav, chips, cards
 * and hero decorations. Colored via `.iti-sparkle` in index.css.
 */
export function Sparkle({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M12 2l1.6 6.4L20 10l-6.4 1.6L12 18l-1.6-6.4L4 10l6.4-1.6L12 2z" />
    </svg>
  );
}

export function LogoMark() {
  return (
    <div className="flex items-center gap-2" data-testid="nav-logo">
      <span className="iti-sparkle"><Sparkle className="w-5 h-5" /></span>
      <span className="font-display text-[17px] font-extrabold tracking-tight text-slate-900">
        Interest to Income
      </span>
    </div>
  );
}

/**
 * Nav-bar right-side button. Renders "Dashboard" + "Sign out" when logged
 * in and "Sign in" (opens the shared login/signup page) when logged out.
 * The login page hosts BOTH Google and email/password so we don't have
 * to fork the CTA per-provider.
 */
export function CreateAccountBtn({ user, navigate, onLogout, testId }) {
  if (user) {
    return (
      <div className="flex items-center gap-2" data-testid="nav-auth-actions">
        <button
          onClick={() => navigate("/dashboard")}
          data-testid={testId || "nav-dashboard-btn"}
          className="iti-btn-outline px-4 py-2 text-sm font-semibold inline-flex items-center gap-2"
        >
          <UserCircle2 className="w-4 h-4" />
          Dashboard
        </button>
        <button
          onClick={async () => {
            if (onLogout) await onLogout();
            navigate("/");
          }}
          data-testid="nav-signout-btn"
          className="iti-btn-outline px-4 py-2 text-sm font-semibold inline-flex items-center gap-2"
        >
          <LogOut className="w-4 h-4" />
          Sign out
        </button>
      </div>
    );
  }
  return (
    <button
      onClick={() => navigate("/login")}
      data-testid={testId || "nav-create-account-btn"}
      className="iti-btn-outline px-4 py-2 text-sm font-semibold inline-flex items-center gap-2"
    >
      <UserCircle2 className="w-4 h-4" />
      Sign in
    </button>
  );
}
